import type { TareasCountSource } from '../types';

interface TramiteTareasSummary {
  total: number;
  completadas: number;
  porcentaje: number;
}

/**
 * Cálculo puro a partir de los counts que ya vienen en el listado de
 * escrituras (`tareas_count` / `tareas_completadas_count`). A diferencia de
 * `useTramiteStatusSummary` (subtrámites), acá el % es binario sobre el
 * total, no solo sobre las tareas "iniciadas".
 */
export const useTramiteTareasSummary = (
  tramite: TareasCountSource | null | undefined
): TramiteTareasSummary => {
  const total = tramite?.tareas_count ?? 0;
  const completadas = tramite?.tareas_completadas_count ?? 0;
  const porcentaje = total > 0 ? (completadas / total) * 100 : 0;

  return { total, completadas, porcentaje };
};

export default useTramiteTareasSummary;
